import { configure } from 'vee-validate';
import { i18n } from '@/utilities/i18n';
const t = i18n.global.t;

function setupValidationConfig() {
    configure({
        validateOnBlur: true, // controls if `blur` events should trigger validation with `handleChange` handler
        validateOnChange: true, // controls if `change` events should trigger validation with `handleChange` handler
        validateOnInput: true, // controls if `input` events should trigger validation with `handleChange` handler
        validateOnModelUpdate: true, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
        generateMessage: (ctx) => {
            const messages: { [key: string]: string } = {
                required: t('validationMsg.required'),
                email: t('validationMsg.validEmail'),
                min: t('validationMsg.minLength', {
                    limit: Array.isArray(ctx.rule?.params)
                        ? ctx.rule?.params?.[0]
                        : ctx.rule?.params?.length,
                }),
                max: t('validationMsg.maxLength', {
                    limit: Array.isArray(ctx.rule?.params)
                        ? ctx.rule?.params?.[0]
                        : ctx.rule?.params?.length,
                }),
                between: t('validationMsg.between', {
                    min: Array.isArray(ctx.rule?.params)
                        ? ctx.rule?.params?.[0]
                        : ctx.rule?.params?.min,
                    max: Array.isArray(ctx.rule?.params)
                        ? ctx.rule?.params?.[1]
                        : ctx.rule?.params?.max,
                }),
            };
            const message = ctx.rule ? messages[ctx.rule.name] : 'Validation Error';
            return message;
        },
    });
}

export default setupValidationConfig;
